define('SuiteDynamics.ItemExtensions',
	[
		'SuiteDynamics.Item.KeyMapping.Extended'
	],
	function (
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {}
	};
});
